import { ADDRESS_ZERO } from "../address";
import { AMOUNT_ZERO } from "../amount";
import { USD_ONE, USD_ZERO } from "../usd";
import { DEFAULT_PROTOCOL_KEY } from "../constants";
import { PERCENT_ZERO } from "../percent";
import { DEFAULT_CHAIN_KEY } from "../chain-legacy";
import { SKELETON_TOKEN_NAME, SKELETON_TOKEN_SYMBOL } from "../token";
import { MarketAsset } from "./market-asset";

export type DashboardMarketAsset = typeof DashboardMarketAsset.Type;
export type DashboardMarketAssetEncoded = typeof DashboardMarketAsset.Encoded;

export const DashboardMarketAsset = MarketAsset.pick(
  "assetKey",
  "protocolKey",
  "maxLtv",
  "lt",

  "priceNative",
  "priceUsd",

  "collateralTotal",
  "collateralBaseApr",
  "collateralRewardsApr",
  "collateralMerklRewards",
  "collateralPoints",

  "protectedTotal",
  "protectedRewardsApr",
  "protectedMerklRewards",
  "protectedPoints",

  "debtTotal",
  "debtBaseApr",
  "debtRewardsApr",
  "debtMerklRewards",
  "debtPoints",

  "isPaused",
  "isDebtAprFixed",
  "isDisabledCollateral",
  "depositMode",

  "tokenAddress",
  "chainKey",
  "symbol",
  "name",
  "decimals",

  "collateralBalance",
  "collateralBalanceUsd",
  "protectedBalance",
  "protectedBalanceUsd",
  "depositBalanceUsd",
  "debtBalance",
  "debtBalanceUsd",

  "depositLiquidationPriceUsd",
  "debtLiquidationPriceUsd"
).annotations({
  identifier: "DashboardMarketAsset",
});

export const SKELETON_DASHBOARD_MARKET_ASSET: DashboardMarketAsset = {
  assetKey: "base",
  protocolKey: DEFAULT_PROTOCOL_KEY,
  maxLtv: PERCENT_ZERO,
  lt: PERCENT_ZERO,

  priceNative: AMOUNT_ZERO,
  priceUsd: USD_ONE,

  collateralTotal: AMOUNT_ZERO,
  collateralBaseApr: PERCENT_ZERO,
  collateralRewardsApr: PERCENT_ZERO,
  collateralMerklRewards: [],
  collateralPoints: [],

  protectedTotal: AMOUNT_ZERO,
  protectedRewardsApr: PERCENT_ZERO,
  protectedMerklRewards: [],
  protectedPoints: [],

  debtTotal: AMOUNT_ZERO,
  debtBaseApr: PERCENT_ZERO,
  debtRewardsApr: PERCENT_ZERO,
  debtMerklRewards: [],
  debtPoints: [],

  isPaused: false,
  isDebtAprFixed: false,
  isDisabledCollateral: false,
  depositMode: "defaultTrue",

  tokenAddress: ADDRESS_ZERO,
  chainKey: DEFAULT_CHAIN_KEY,
  symbol: SKELETON_TOKEN_SYMBOL,
  name: SKELETON_TOKEN_NAME,
  decimals: 18,

  collateralBalance: AMOUNT_ZERO,
  collateralBalanceUsd: USD_ZERO,
  protectedBalance: AMOUNT_ZERO,
  protectedBalanceUsd: USD_ZERO,
  depositBalanceUsd: USD_ZERO,
  debtBalance: AMOUNT_ZERO,
  debtBalanceUsd: USD_ZERO,

  depositLiquidationPriceUsd: null,
  debtLiquidationPriceUsd: null,
};
